import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Search, ArrowRight } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import api from "@/lib/api";
import Seo from "@/components/Seo";
import AdSlot from "@/components/AdSlot";

export default function GuideIndex() {
  const { lang, L } = useI18n();
  const [pages, setPages] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => { api.get("/seo/pages").then(({ data }) => setPages(data)); }, []);

  const filtered = useMemo(() => {
    if (!q) return pages;
    return pages.filter((p) => (L(p, "title")).toLowerCase().includes(q.toLowerCase()));
  }, [pages, q, L]);

  return (
    <div>
      <Seo title={lang === "it" ? "Guide Beauty & Style" : "Beauty & Style Guides"} description="Migliaia di guide Velyrea su make-up, skincare, armocromia e moda con consigli personalizzati." />
      <div className="olive-bg text-white">
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-14">
          <p className="text-xs uppercase tracking-[0.3em] text-white/80 font-semibold">{lang === "it" ? "Guide Velyrea" : "Velyrea Guides"}</p>
          <h1 className="mt-3 font-serif text-4xl sm:text-5xl lg:text-6xl">{lang === "it" ? "Migliaia di guide su misura" : "Thousands of tailored guides"}</h1>
          <p className="mt-4 max-w-2xl text-white/90 text-lg">{lang === "it" ? "Trova i migliori prodotti per il tuo sottotono, la tua stagione armocromatica e le tue caratteristiche." : "Find the best products for your undertone, color season and features."}</p>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-10">
        <div className="relative max-w-xl mb-8">
          <Search size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-charcoal/40" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder={lang === "it" ? "Cerca una guida..." : "Search a guide..."} data-testid="guide-search" className="w-full pl-10 pr-4 py-3 rounded-full border border-olive/30 bg-white/70 focus:outline-none focus:border-olive" />
        </div>
        <AdSlot format="leaderboard" className="mb-8" />
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="guide-list">
          {filtered.slice(0, 300).map((p) => (
            <Link key={p.slug} to={`/guide/${p.slug}`} data-testid={`guide-${p.slug}`} className="group flex items-center justify-between gap-3 bg-white/80 border border-olive/15 rounded-xl px-4 py-3 hover:border-olive/40 hover:-translate-y-0.5 transition-all">
              <span className="font-medium text-charcoal/85">{L(p, "title")}</span>
              <ArrowRight size={16} className="text-olive opacity-0 group-hover:opacity-100 transition-opacity shrink-0" />
            </Link>
          ))}
        </div>
        <p className="mt-8 text-sm text-charcoal/50">{lang === "it" ? `${pages.length}+ guide disponibili — nuove pagine aggiunte di continuo.` : `${pages.length}+ guides available — new pages added continuously.`}</p>
      </div>
    </div>
  );
}
